{
    angular.module('interfaceModule')
        .controller('AboutUsController',AboutUsController);
    AboutUsController.$inject = ['$scope',"utils.currentUser",'utils.constant','$state'];
    function AboutUsController($scope,currentUser,constant,$state) {
        let vm=this;
        let collect={
            'activate':activate,

        };
        vm.collect=collect;
        activate();

        function activate(){

        }
    }

}